/**
 * GENERATED by frontend/scripts/generate-subcategory-tags.ts — do not edit.
 * Regenerate with `npm run generate:subcategory-tags` after changing appendix A
 * of .agents/specs/ag-249-kategoritaggar/1-analys.md or the shelf table in the
 * script. The functions that read these tables live in ./subcategoryTags.ts.
 *
 * 101 former categories, 13 subset rules.
 */

/** Former `DocumentCategory.name` → the canonical (sorted, |-joined) tag key. */
export const TAG_KEY_BY_CATEGORY_NAME: Record<string, string> = {
  ANIMAL_CARE_PROTOCOL: 'djur|djurhalsa|rutin',
  ANIMAL_CONVERSION_APPROVAL: 'djur|eko|omstallningsstart',
  ANIMAL_ID_CONTROL: 'djur|markning',
  ANIMAL_PROCEDURE_RECORD: 'avhorning|djur|djurhalsa|journal',
  ANIMAL_PURCHASE: 'djur|faktura|livdjur',
  ANIMAL_SALE: 'djur|forsaljning|livdjur',
  ANIMAL_WELFARE_ASSESSMENT: 'djur|djurvalfard|protokoll',
  ANIMAL_WELFARE_REPORT: 'djur|djurvalfard|rapport',
  ANNUAL_BARN_CLEANING: 'djur|journal|rengoring|stall',
  AUTHORITY_REPORT: 'garden|myndighet|rapport',
  BARN_LAYOUT_PLAN: 'djur|ritning|stall',
  BARN_RECORD: 'djur|journal|stall',
  BIODIVERSITY_PLAN: 'biologisk-mangfald|miljo|plan',
  BIOSECURITY_CERTIFICATE: 'certifikat|djur|smittskydd',
  BIOSECURITY_MAP: 'djur|karta|smittskydd',
  CALF_SURVIVAL_STATISTICS: 'djur|dodlighet|kalv|not|statistik',
  CALIBRATION_RECORD: 'intyg|utrustning|vaxtodling|vaxtskydd',
  CERTIFICATE_KRAV: 'certifiering|certifikat|krav',
  CERTIFICATE_SPCR120: 'certifiering|certifikat|godsel|spcr120',
  CLEANING_RECORD: 'garden|journal|rengoring',
  CLIMATE_CALCULATION: 'berakning|klimat|miljo',
  CONTROL_PROGRAM_REPORT: 'garden|kontrollprogram|rapport',
  COW_SURVIVAL_STATISTICS: 'djur|dodlighet|mjolk|not|statistik',
  CROP_PLAN: 'groda|plan|vaxtodling',
  CROP_ROTATION_REPORT: 'vaxtfoljd|vaxtodling',
  DAIRY_EQUIPMENT_ROUTINE: 'djur|mjolk|rutin|utrustning',
  DAIRY_EQUIPMENT_TEST: 'besiktning|djur|mjolk|utrustning',
  DISEASE_OUTBREAK: 'djur|djurhalsa|rapport|smittskydd',
  ECO_DRIVING_CERTIFICATE: 'bransle|intyg|miljo|utbildning',
  EMERGENCY_CONTACT_LIST: 'arbetsmiljo|larm|rutin',
  ENERGY_AUDIT: 'energi|miljo|rapport',
  EQUIPMENT_INSPECTION_FUEL: 'besiktning|bransle|miljo',
  EQUIPMENT_INSPECTION_HVAC: 'besiktning|garden|koldmedier|utrustning',
  FEED_ADDITIVES: 'djur|foder|insatsvaror|tillsatser',
  FEED_ANALYSIS: 'analys|djur|foder',
  FEED_CONSUMPTION_CALCULATION: 'berakning|djur|foder',
  FEED_PURCHASE: 'djur|faktura|foder|insatsvaror',
  FEED_RATION: 'djur|foder|plan',
  FEED_TRADE_RECORD: 'djur|foder|forsaljning|insatsvaror|journal',
  FERTILIZER_PLAN: 'godsel|plan|vaxtodling',
  FERTILIZER_RECORD: 'godsel|journal|vaxtodling',
  FIELD_MAP: 'karta|vaxtodling',
  FIELD_RECORD: 'journal|vaxtodling',
  GRAIN_SETTLEMENT: 'avrakning|forsaljning|vaxtodling',
  GRAZING_RECORD: 'bete|djur|journal',
  HARVEST_RECORD: 'journal|skord|vaxtodling',
  INSPECTION_REPORT: 'garden|rapport',
  INVOICE: 'faktura|garden',
  INVOICE_INPUTS: 'faktura|insatsvaror|vaxtodling',
  INVOICE_SEED: 'faktura|insatsvaror|utsade|vaxtodling',
  LEASE_AGREEMENT: 'avtal|garden|mark',
  MAINTENANCE_RECORD: 'garden|journal|underhall',
  MANAGEMENT_PLAN: 'garden|plan',
  MANURE_ANALYSIS: 'analys|godsel|vaxtodling',
  MANURE_SPREADING_AGREEMENT: 'avtal|godsel|vaxtodling',
  MANURE_STORAGE_CALCULATION: 'berakning|godsel|lagring|vaxtodling',
  MEDICATION_PRESCRIPTION: 'djur|kvitto|lakemedel',
  MEDICATION_RECORD: 'djur|journal|lakemedel',
  MHS_ACTION_PLAN: 'miljo|miljohusesyn|plan',
  MILK_REPLACER_RECORD: 'djur|foder|journal|mjolkersattning',
  MILK_SETTLEMENT: 'avrakning|djur|forsaljning|mjolk',
  MORTALITY_RECORD: 'djur|dodlighet|journal',
  MUNICIPAL_PESTICIDE_PERMIT: 'myndighet|tillstand|vaxtodling|vaxtskydd',
  NUTRIENTS_BALANCE: 'berakning|vaxtnaring|vaxtodling',
  PACKAGING_LABEL_KRAV: 'krav|livsmedel|markning',
  PACKAGING_SUSTAINABILITY: 'forpackning|livsmedel',
  PEST_CONTROL: 'garden|skadedjur',
  PESTICIDE_PERMIT: 'tillstand|vattenskyddsomrade|vaxtodling|vaxtskydd',
  PHOSPHORUS_BALANCE: 'berakning|fosfor|vaxtnaring|vaxtodling',
  PLANT_PROTECTION_PERMIT: 'tillstand|utbildning|vaxtodling|vaxtskydd',
  RECEIPT_TANKER: 'djur|kvitto|mjolk',
  RECEPTION_CONTROL_RECORD: 'garden|insatsvaror|journal',
  RENEWABLE_ENERGY_CONTRACT: 'avtal|energi|miljo',
  RISK_ASSESSMENT: 'garden|plan|risk',
  SAFETY_DATA_SHEET: 'arbetsmiljo|sakerhetsdatablad',
  SAFETY_DATA_SHEET_DETERGENT: 'arbetsmiljo|rengoring|sakerhetsdatablad',
  SAFETY_DATA_SHEET_RODENTICIDE: 'arbetsmiljo|sakerhetsdatablad|skadedjur',
  SALES_RECORD: 'forsaljning|garden|journal',
  SALES_VERIFICATION: 'forsaljning|kvitto|vaxtodling',
  SAM_APPLICATION: 'ansokan|garden|sam',
  SEED_EXEMPTION_DECISION: 'tillstand|utsade|vaxtodling',
  SEED_RECORD: 'journal|utsade|vaxtodling',
  SERVICE_MILK_TANK: 'besiktning|djur|mjolk|service|utrustning',
  SITE_PLAN: 'garden|karta',
  SLAUGHTER_SETTLEMENT: 'avrakning|djur|forsaljning|slakt',
  SOIL_ANALYSIS: 'analys|mark|vaxtodling',
  SOIL_MAPPING: 'analys|mark|markkartering|vaxtodling',
  SPRAY_RECORD: 'journal|vaxtodling|vaxtskydd',
  SPRAYER_FUNCTION_TEST: 'intyg|myndighet|utrustning|vaxtodling|vaxtskydd',
  STORAGE_RECORD: 'garden|journal|lagring',
  SUBCONTRACTOR_AGREEMENT: 'avtal|garden|underleverantor',
  SUPPLIER_CERTIFICATE: 'certifiering|certifikat|insatsvaror',
  TRAINING_RECORD: 'intyg|utbildning|vaxtodling|vaxtskydd',
  TRANSPORT_RECORD: 'avfall|journal|miljo|transport',
  TREATMENT_PROTOCOL: 'djur|lakemedel|rutin',
  TREATMENT_RECORD: 'djur|intyg|lakemedel',
  WASTE_RECEIPTS: 'avfall|kvitto|miljo',
  WASTE_RECORD: 'avfall|journal|miljo',
  WATER_ANALYSIS: 'analys|garden|vatten',
  WORK_ENVIRONMENT_MEETING: 'arbetsmiljo|protokoll',
  WORK_ENVIRONMENT_PLAN: 'arbetsmiljo|plan',
};

/** Tag key → the title the former category carried (appendix A, "Visningsnamn"). */
export const DISPLAY_NAME_BY_TAG_KEY: Record<string, string> = {
  'analys|djur|foder': 'Foderanalys',
  'analys|garden|vatten': 'Vattenanalys',
  'analys|godsel|vaxtodling': 'Gödselanalys',
  'analys|mark|markkartering|vaxtodling': 'Markkartering',
  'analys|mark|vaxtodling': 'Jordanalys',
  'ansokan|garden|sam': 'SAM-ansökan',
  'arbetsmiljo|larm|rutin': 'Larmlista',
  'arbetsmiljo|plan': 'Arbetsmiljöplan',
  'arbetsmiljo|protokoll': 'Handlingar arbetsmiljö',
  'arbetsmiljo|rengoring|sakerhetsdatablad': 'Säkerhetsdatablad diskmedel',
  'arbetsmiljo|sakerhetsdatablad': 'Säkerhetsdatablad',
  'arbetsmiljo|sakerhetsdatablad|skadedjur': 'Säkerhetsdatablad råttgift',
  'avfall|journal|miljo': 'Avfallsjournal',
  'avfall|journal|miljo|transport': 'Transportjournal',
  'avfall|kvitto|miljo': 'Kvitton avfall',
  'avhorning|djur|djurhalsa|journal': 'Djuråtgärdsjournal',
  'avrakning|djur|forsaljning|mjolk': 'Mjölkavräkning',
  'avrakning|djur|forsaljning|slakt': 'Slaktavräkning',
  'avrakning|forsaljning|vaxtodling': 'Spannmålsavräkning',
  'avtal|energi|miljo': 'Avtal förnybar el',
  'avtal|garden|mark': 'Arrendeavtal',
  'avtal|garden|underleverantor': 'Avtal med underleverantör',
  'avtal|godsel|vaxtodling': 'Spridningsavtal gödsel',
  'berakning|djur|foder': 'Beräkning av kraftfoderåtgång',
  'berakning|fosfor|vaxtnaring|vaxtodling': 'Fosforbalans',
  'berakning|godsel|lagring|vaxtodling': 'Lagringskapacitet för stallgödsel',
  'berakning|klimat|miljo': 'Klimatberäkning',
  'berakning|vaxtnaring|vaxtodling': 'Växtnäringsbalans',
  'besiktning|bransle|miljo': 'Besiktningsprotokoll bränslelagring',
  'besiktning|djur|mjolk|service|utrustning': 'Service av mjölktank',
  'besiktning|djur|mjolk|utrustning': 'Test av mjölkutrustning',
  'besiktning|garden|koldmedier|utrustning': 'Besiktningsprotokoll klimatanläggning',
  'bete|djur|journal': 'Betesjournal',
  'biologisk-mangfald|miljo|plan': 'Skötselplan biologisk mångfald',
  'bransle|intyg|miljo|utbildning': 'Intyg sparsamt körsätt',
  'certifiering|certifikat|godsel|spcr120': 'Certifikat SPCR120',
  'certifiering|certifikat|insatsvaror': 'Leverantörscertifikat',
  'certifiering|certifikat|krav': 'Certifikat KRAV',
  'certifikat|djur|smittskydd': 'Smittsäkrad besättning',
  'djur|djurhalsa|rapport|smittskydd': 'Utredningar vid sjukdomsutbrott',
  'djur|djurhalsa|rutin': 'Djurskötselrutin',
  'djur|djurvalfard|protokoll': 'Djurvälfärdsbedömning',
  'djur|djurvalfard|rapport': 'Signaler djurvälfärd',
  'djur|dodlighet|journal': 'Djurjournal om döda djur',
  'djur|dodlighet|kalv|not|statistik': 'Överlevnadstal kalvar',
  'djur|dodlighet|mjolk|not|statistik': 'Överlevnadsstatistik mjölkko',
  'djur|eko|omstallningsstart': 'Godkännande omställningsstart',
  'djur|faktura|foder|insatsvaror': 'Foderinköp',
  'djur|faktura|livdjur': 'Dokumentation inköpta djur',
  'djur|foder|forsaljning|insatsvaror|journal': 'Införskaffat och avyttrat foder/grödor/primärprodukter',
  'djur|foder|insatsvaror|tillsatser': 'Dokumentation över foderstillsatser',
  'djur|foder|journal|mjolkersattning': 'Journalföring av djur som fått mjölkersättning',
  'djur|foder|plan': 'Foderstat',
  'djur|forsaljning|livdjur': 'Dokumentation levererade livdjur',
  'djur|intyg|lakemedel': 'Behandlingsbevis',
  'djur|journal|lakemedel': 'Läkemedelsjournal',
  'djur|journal|rengoring|stall': 'Årlig stallrengöring',
  'djur|journal|stall': 'Stalljournal',
  'djur|karta|smittskydd': 'Smittskyddskarta',
  'djur|kvitto|lakemedel': 'Recept/kvitton läkemedel',
  'djur|kvitto|mjolk': 'Tankbilskvitto',
  'djur|lakemedel|rutin': 'Behandlingsrutin',
  'djur|markning': 'Öronmärkeskontroll',
  'djur|mjolk|rutin|utrustning': 'Rutiner mjölkutrustning',
  'djur|ritning|stall': 'Stallritning',
  'energi|miljo|rapport': 'Energikartläggning',
  'faktura|garden': 'Faktura',
  'faktura|insatsvaror|utsade|vaxtodling': 'Faktura utsäde',
  'faktura|insatsvaror|vaxtodling': 'Faktura insatsmedel',
  'forpackning|livsmedel': 'Dokumentation förpackningar',
  'forsaljning|garden|journal': 'Försäljningsjournal',
  'forsaljning|kvitto|vaxtodling': 'Verifikationer sålda produkter',
  'garden|insatsvaror|journal': 'Journal mottagna insatsvaror',
  'garden|journal|lagring': 'Lagringsjournal',
  'garden|journal|rengoring': 'Rengöringsjournal',
  'garden|journal|underhall': 'Underhållsjournal',
  'garden|karta': 'Situationsplan',
  'garden|kontrollprogram|rapport': 'Handlingar från besök inom kontrollprogram',
  'garden|myndighet|rapport': 'Kontrollrapport LST/kommunen',
  'garden|plan': 'Förvaltningsplan',
  'garden|plan|risk': 'Riskbedömning',
  'garden|rapport': 'Inspektionsrapport',
  'garden|skadedjur': 'Skadedjurskontroll',
  'godsel|journal|vaxtodling': 'Gödseljournal',
  'godsel|plan|vaxtodling': 'Gödselplan',
  'groda|plan|vaxtodling': 'Växtodlingsplan',
  'intyg|myndighet|utrustning|vaxtodling|vaxtskydd': 'Beslut funktionstest spridningsutrustning',
  'intyg|utbildning|vaxtodling|vaxtskydd': 'Utbildningsbevis',
  'intyg|utrustning|vaxtodling|vaxtskydd': 'Kalibreringsbevis',
  'journal|skord|vaxtodling': 'Skördejournal',
  'journal|utsade|vaxtodling': 'Utsädesjournal',
  'journal|vaxtodling': 'Fältjournal',
  'journal|vaxtodling|vaxtskydd': 'Sprutjournal',
  'karta|vaxtodling': 'Karta över fält',
  'krav|livsmedel|markning': 'Märkning förpackning KRAV',
  'miljo|miljohusesyn|plan': 'Åtgärdsplan Miljöhusesyn',
  'myndighet|tillstand|vaxtodling|vaxtskydd': 'Kommunalt tillstånd växtskydd',
  'tillstand|utbildning|vaxtodling|vaxtskydd': 'Tillstånd växtskydd',
  'tillstand|utsade|vaxtodling': 'Undantagsbeslut utsäde',
  'tillstand|vattenskyddsomrade|vaxtodling|vaxtskydd': 'Tillstånd spridning växtskyddsmedel i vattenskyddsområde',
  'vaxtfoljd|vaxtodling': 'Växtföljdsredovisning',
};

/** Tag key → pärm shelf for every former category, so migrated documents stay put. */
export const SUBCATEGORY_BY_EXACT_TAGS: Record<string, string> = {
  'analys|djur|foder': 'djur-foder',
  'analys|garden|vatten': 'vaxtodling-livsmedel',
  'analys|godsel|vaxtodling': 'allmanna-ovrigt',
  'analys|mark|markkartering|vaxtodling': 'vaxtodling-spridning',
  'analys|mark|vaxtodling': 'vaxtodling-spridning',
  'ansokan|garden|sam': 'cert-stod',
  'arbetsmiljo|larm|rutin': 'arbetsmiljo-skydd',
  'arbetsmiljo|plan': 'arbetsmiljo-sam',
  'arbetsmiljo|protokoll': 'arbetsmiljo-sam',
  'arbetsmiljo|rengoring|sakerhetsdatablad': 'allmanna-kemiska',
  'arbetsmiljo|sakerhetsdatablad': 'allmanna-kemiska',
  'arbetsmiljo|sakerhetsdatablad|skadedjur': 'allmanna-kemiska',
  'avfall|journal|miljo': 'allmanna-avfall',
  'avfall|journal|miljo|transport': 'allmanna-ovrigt',
  'avfall|kvitto|miljo': 'allmanna-avfall',
  'avhorning|djur|djurhalsa|journal': 'djur-journaler',
  'avrakning|djur|forsaljning|mjolk': 'djur-transport',
  'avrakning|djur|forsaljning|slakt': 'djur-transport',
  'avrakning|forsaljning|vaxtodling': 'vaxtodling-sparbarhet',
  'avtal|energi|miljo': 'allmanna-ovrigt',
  'avtal|garden|mark': 'allmanna-ovrigt',
  'avtal|garden|underleverantor': 'allmanna-ovrigt',
  'avtal|godsel|vaxtodling': 'vaxtodling-spridning',
  'berakning|djur|foder': 'djur-foder',
  'berakning|fosfor|vaxtnaring|vaxtodling': 'allmanna-ovrigt',
  'berakning|godsel|lagring|vaxtodling': 'vaxtodling-lagring',
  'berakning|klimat|miljo': 'allmanna-ovrigt',
  'berakning|vaxtnaring|vaxtodling': 'allmanna-ovrigt',
  'besiktning|bransle|miljo': 'allmanna-cisterner',
  'besiktning|djur|mjolk|service|utrustning': 'allmanna-ovrigt',
  'besiktning|djur|mjolk|utrustning': 'djur-halsa',
  'besiktning|garden|koldmedier|utrustning': 'allmanna-kyl',
  'bete|djur|journal': 'djur-journaler',
  'biologisk-mangfald|miljo|plan': 'allmanna-ovrigt',
  'bransle|intyg|miljo|utbildning': 'allmanna-energi',
  'certifiering|certifikat|godsel|spcr120': 'cert-certifikat',
  'certifiering|certifikat|insatsvaror': 'cert-certifikat',
  'certifiering|certifikat|krav': 'cert-certifikat',
  'certifikat|djur|smittskydd': 'djur-halsa',
  'djur|djurhalsa|rapport|smittskydd': 'allmanna-ovrigt',
  'djur|djurhalsa|rutin': 'djur-halsa',
  'djur|djurvalfard|protokoll': 'djur-halsa',
  'djur|djurvalfard|rapport': 'allmanna-ovrigt',
  'djur|dodlighet|journal': 'djur-journaler',
  'djur|dodlighet|kalv|not|statistik': 'djur-halsa',
  'djur|dodlighet|mjolk|not|statistik': 'djur-halsa',
  'djur|eko|omstallningsstart': 'allmanna-ovrigt',
  'djur|faktura|foder|insatsvaror': 'djur-foder',
  'djur|faktura|livdjur': 'djur-journaler',
  'djur|foder|forsaljning|insatsvaror|journal': 'djur-foder',
  'djur|foder|insatsvaror|tillsatser': 'allmanna-ovrigt',
  'djur|foder|journal|mjolkersattning': 'allmanna-ovrigt',
  'djur|foder|plan': 'djur-foder',
  'djur|forsaljning|livdjur': 'djur-journaler',
  'djur|intyg|lakemedel': 'djur-journaler',
  'djur|journal|lakemedel': 'djur-journaler',
  'djur|journal|rengoring|stall': 'djur-halsa',
  'djur|journal|stall': 'djur-journaler',
  'djur|karta|smittskydd': 'djur-halsa',
  'djur|kvitto|lakemedel': 'djur-halsa',
  'djur|kvitto|mjolk': 'allmanna-ovrigt',
  'djur|lakemedel|rutin': 'djur-halsa',
  'djur|markning': 'djur-journaler',
  'djur|mjolk|rutin|utrustning': 'djur-halsa',
  'djur|ritning|stall': 'allmanna-ovrigt',
  'energi|miljo|rapport': 'allmanna-ovrigt',
  'faktura|garden': 'allmanna-ovrigt',
  'faktura|insatsvaror|utsade|vaxtodling': 'vaxtodling-sparbarhet',
  'faktura|insatsvaror|vaxtodling': 'allmanna-ovrigt',
  'forpackning|livsmedel': 'allmanna-ovrigt',
  'forsaljning|garden|journal': 'allmanna-ovrigt',
  'forsaljning|kvitto|vaxtodling': 'allmanna-ovrigt',
  'garden|insatsvaror|journal': 'allmanna-ovrigt',
  'garden|journal|lagring': 'allmanna-ovrigt',
  'garden|journal|rengoring': 'allmanna-ovrigt',
  'garden|journal|underhall': 'allmanna-ovrigt',
  'garden|karta': 'allmanna-ovrigt',
  'garden|kontrollprogram|rapport': 'allmanna-ovrigt',
  'garden|myndighet|rapport': 'allmanna-tillstand',
  'garden|plan': 'allmanna-ovrigt',
  'garden|plan|risk': 'allmanna-egenkontroll',
  'garden|rapport': 'allmanna-tillstand',
  'garden|skadedjur': 'vaxtodling-livsmedel',
  'godsel|journal|vaxtodling': 'vaxtodling-spridning',
  'godsel|plan|vaxtodling': 'vaxtodling-spridning',
  'groda|plan|vaxtodling': 'vaxtodling-spridning',
  'intyg|myndighet|utrustning|vaxtodling|vaxtskydd': 'vaxtodling-vaxtskydd',
  'intyg|utbildning|vaxtodling|vaxtskydd': 'vaxtodling-vaxtskydd',
  'intyg|utrustning|vaxtodling|vaxtskydd': 'vaxtodling-vaxtskydd',
  'journal|skord|vaxtodling': 'vaxtodling-sparbarhet',
  'journal|utsade|vaxtodling': 'vaxtodling-sparbarhet',
  'journal|vaxtodling': 'vaxtodling-sparbarhet',
  'journal|vaxtodling|vaxtskydd': 'vaxtodling-vaxtskydd',
  'karta|vaxtodling': 'vaxtodling-sparbarhet',
  'krav|livsmedel|markning': 'allmanna-ovrigt',
  'miljo|miljohusesyn|plan': 'allmanna-egenkontroll',
  'myndighet|tillstand|vaxtodling|vaxtskydd': 'vaxtodling-vaxtskydd',
  'tillstand|utbildning|vaxtodling|vaxtskydd': 'vaxtodling-vaxtskydd',
  'tillstand|utsade|vaxtodling': 'vaxtodling-sparbarhet',
  'tillstand|vattenskyddsomrade|vaxtodling|vaxtskydd': 'vaxtodling-vaxtskydd',
  'vaxtfoljd|vaxtodling': 'vaxtodling-vaxtfoljd',
};

/**
 * Shelves a new tag combination can reach by subset: the tags every member of
 * the shelf shares, when that is at least two tags and no other shelf's member
 * carries them all. Most specific first.
 */
export const SUBCATEGORY_BY_TAG_SUBSET: ReadonlyArray<{ id: string; tags: readonly string[] }> = [
  { id: 'vaxtodling-lagring', tags: ['berakning', 'godsel', 'lagring', 'vaxtodling'] },
  { id: 'allmanna-cisterner', tags: ['besiktning', 'bransle', 'miljo'] },
  { id: 'allmanna-kyl', tags: ['besiktning', 'garden', 'utrustning'] },
  { id: 'arbetsmiljo-skydd', tags: ['arbetsmiljo', 'larm', 'rutin'] },
  { id: 'cert-stod', tags: ['ansokan', 'garden', 'sam'] },
  { id: 'djur-transport', tags: ['avrakning', 'djur', 'forsaljning'] },
  { id: 'allmanna-avfall', tags: ['avfall', 'miljo'] },
  { id: 'allmanna-kemiska', tags: ['arbetsmiljo', 'sakerhetsdatablad'] },
  { id: 'allmanna-tillstand', tags: ['garden', 'rapport'] },
  { id: 'cert-certifikat', tags: ['certifiering', 'certifikat'] },
  { id: 'djur-foder', tags: ['djur', 'foder'] },
  { id: 'vaxtodling-vaxtfoljd', tags: ['vaxtfoljd', 'vaxtodling'] },
  { id: 'vaxtodling-vaxtskydd', tags: ['vaxtodling', 'vaxtskydd'] },
];
